import { createInstance } from "@optimizely/react-sdk"
import * as env from "lib/env"

export const optimizely = createInstance({
    sdkKey: env.OPTIMIZELY_KEY,
})
